class GalleryFilterComponent extends HTMLElement {
  connectedCallback() {
    this.filters = Array.from(this.querySelectorAll('[data-filter]'));
    this.cards = Array.from(this.querySelectorAll('[data-category]'));
    this.loadMoreButton = this.querySelector('[data-load-more]');
    this.pageSize = 9;
    this.visibleCount = this.pageSize;
    this.activeFilter = 'all';

    this.hideEmptyFilters();
    this.applyState();

    this.filters.forEach((button) => {
      button.addEventListener('click', () => {
        this.activeFilter = button.dataset.filter;
        this.visibleCount = this.pageSize;
        this.filters.forEach((other) => other.classList.toggle('is-active', other === button));
        this.applyState();
      });
    });

    if (this.loadMoreButton) {
      this.loadMoreButton.addEventListener('click', () => {
        this.visibleCount += this.pageSize;
        this.applyState();
      });
    }
  }

  hideEmptyFilters() {
    this.filters.forEach((button) => {
      const filter = button.dataset.filter;
      if (filter === 'all') return;
      const hasMatch = this.cards.some((card) => this.matches(card, filter));
      if (!hasMatch) button.hidden = true;
    });
  }

  // "In the workshop" filters on build status; every other pill on vehicle category
  matches(card, filter) {
    if (filter === 'all') return true;
    if (filter === 'in-the-workshop') return card.dataset.status === filter;
    return card.dataset.category === filter;
  }

  applyState() {
    const matches = this.cards.filter((card) => this.matches(card, this.activeFilter));

    this.cards.forEach((card) => {
      card.hidden = !matches.includes(card);
    });

    matches.forEach((card, index) => {
      card.hidden = index >= this.visibleCount;
    });

    if (this.loadMoreButton) {
      this.loadMoreButton.hidden = matches.length <= this.visibleCount;
    }
  }
}

customElements.define('gallery-filter-component', GalleryFilterComponent);
